import React, { useEffect, useState, useRef } from "react";
import api from "../../api/api";

//~----------------Toast component and Sweet Alert-----------------------------
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";

//~--------------------Header component---------------------------------------------
import MuiHeader from "../../components/MuiHeader";

//~------------------------------MUI components---------------------------------------
import {
  Button,
  Box,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  FormControl,
  OutlinedInput,
  Chip,
  Checkbox,
  Radio,
  ListItemText,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useStepContext,
  CircularProgress,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";

//~-------------------------------Azure Components to upload and delete media------------------
import { deleteFileFromDB, UploadFileToAzureDB } from "../../components/Azure";
import {
  getAllModules,
  getAllProgramTypes,
  getAllTopics,
  getAllsubModules,
} from "../PedagogySection/Pedagogy.Thunk";

import {
  saveGamifiedQuiz,
  getAllGamifiedQuizzes,
  updateGamifiedQuiz,
  deleteGamifiedQuiz,
} from "./TrainingExtraResources.Thunk";

const GamifiedModule = () => {
  //&-----------------Dropdown elements--------------------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];

  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "Anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
  ];

  //?----------------States for training type---------
  const [preferedlanguage, setPreferedlanguage] = useState("od");
  const [usertype, setUsertype] = useState("fellow");
  const [programtype, setProgramtype] = useState("");
  const [programData, setProgramData] = useState([]);
  const [modules, setModules] = useState([]);
  const [selModuleDetails, setSelModuleDetails] = useState("");
  const [subModules, setSubModules] = useState([]);
  const [selSubModuleDetails, setSelSubModuleDetails] = useState("");
  const [topics, setTopics] = useState([]);
  const [selTopicDetails, setSelTopicDetails] = useState("");
  const [quizzType, setQuizzType] = useState("");
  const [assignmentData, setAssignmentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);

  //?-------------States for the gamified quizes--------
  const quizMediaFileRef = useRef();
  const [show, setShow] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [fileExtensionType, setFileExtensionType] = useState("");
  const [myFile, setMyFile] = useState("");
  const [accept, setAccept] = useState("");
  const [questionMediaType, setQuestionMediaType] = useState("");
  const [showUploadPanel, setShowUploadPanel] = useState(false);
  //^-------------------- All answer types------------------------------------------------
  const [showOptions2, setShowOptions2] = useState(false);
  const [showOptions3, setShowOptions3] = useState(false);
  const [showOptions4, setShowOptions4] = useState(false);
  const [showOptionsYN, setShowOptionsYN] = useState(false);
  const [answerType, setAnswerType] = useState("");

  //^---------------------- answerMedia (whether text or image)-------------------------
  const [answerMedia, setAnswerMedia] = useState("");

  //^---------------------- Question set and Question media selection -------------------------
  const [questionOrder, setQuestionOrder] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [question, setQuestion] = useState("");
  const [questionMedia, setQuestionMedia] = useState("");
  const [link, setLink] = useState("");
  //^--------------------- Instruction -------------------------
  const [instructions, setInstructions] = useState("");

  //^--------------------- Hints -------------------------
  const [hints, setHints] = useState("");

  const [filePreview, setFilePreview] = useState(null);

  //^--------------QuizData--------------------------------
  const [quizes, setQuizes] = useState([]);

  // Quiz Object
  let quiz_object = {
    questionOrder: 0,
    questionId: "",
    question: "",
    questionMediaType: "",
    questionMedia: "",
    instructions: "",
    answerType: "",
    optionA: "",
    optionB: "",
    optionC: "",
    optionD: "",
    correctOption: [],
  };
  // ------------------------------------------------------------

  useEffect(() => {
    const data = {
      language: preferedlanguage,
      usertype: "fellow",
    };
    getAllProgramTypes(data).then((modules) => {
      setProgramData(modules.data);
    });
  }, []);

  //*---------Language change function--------
  const preflanguage_select_onchange = (e) => {
    if (!e.target.value) {
      setPreferedlanguage("");
      setUsertype("");
      setProgramtype("");
      setProgramData([]);
      setModules([]);
      setSelModuleDetails("");
      setSubModules([]);
      setSelSubModuleDetails("");
      setTopics([]);
      setSelTopicDetails("");
    } else {
      setUsertype("");
      setProgramtype("");
      setSelModuleDetails("");
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      setPreferedlanguage(e.target.value);
      setQuizes([]);
    }
  };

  //*----------Usertype change function--------
  const usertype_select_onchange = (e) => {
    if (!e.target.value) {
      setUsertype("");
      setProgramtype("");
      setProgramData([]);
      setModules([]);
      setSelModuleDetails("");
      setSubModules([]);
      setSelSubModuleDetails("");
      setTopics([]);
      setSelTopicDetails("");
      setQuizes([]);
    } else {
      setUsertype(e.target.value);
      setProgramtype("");
      setSelModuleDetails("");
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      setQuizes([]);
      setLoading(true);
      const data = {
        language: preferedlanguage,
        usertype: e.target.value,
      };
      getAllProgramTypes(data).then((modules) => {
        setProgramData(modules.data);
        setLoading(false);
      });
    }
  };

  //*---------Programtype change function---------
  const program_select_onchange = (event) => {
    if (!event.target.value) {
      setProgramtype("");
      setQuizes([]);
      setModules([]);
      setSelModuleDetails("");
      setSubModules([]);
      setSelSubModuleDetails("");
      setTopics([]);
      setSelTopicDetails("");
    } else {
      setLoading(true);
      setProgramtype(event.target.value);
      setSelModuleDetails("");
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      setQuizes([]);
      const data = {
        trainingType: event.target.value,
        usertype: usertype,
        language: preferedlanguage,
      };

      getAllModules(data).then((modules) => {
        setModules(modules.data);
        setLoading(false);
      });
    }
  };

  //*------------Module change function------------
  const module_select_onchange = (e) => {
    if (!e.target.value) {
      setSelModuleDetails("");
      setQuizes([]);
      setSubModules([]);
      setSelSubModuleDetails("");
      setTopics([]);
      setSelTopicDetails("");
    } else {
      setLoading(true);
      setQuizes([]);
      setSelModuleDetails(e.target.value);
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      const data = {
        usertype: usertype,
        language: preferedlanguage,
        trainingType: programtype,
        moduleid: e.target.value,
      };
      getAllsubModules(data).then((submodules) => {
        setSubModules(submodules.data);
        setLoading(false);
      });
    }
  };

  //*-------------Submodule change function---------
  const submodule_select_onchange = (e) => {
    if (!e.target.value) {
      setSelSubModuleDetails("");
      setSelTopicDetails("");
      setTopics([]);
      setQuizes([]);
    } else {
      setLoading(true);
      setQuizes([]);
      setSelSubModuleDetails(e.target.value);
      setSelTopicDetails("");
      setTopics([]);

      const data = {
        trainingType: programtype,
        usertype: usertype,
        language: preferedlanguage,
        moduleid: selModuleDetails,
        submoduleid: e.target.value,
      };

      getAllTopics(data).then((topic) => {
        setTopics(topic.data);
        setLoading(false);
      });
    }
  };

  //*----------------topic change function------------
  const topic_select_onchange = (e) => {
    if (!e.target.value) {
      setSelTopicDetails("");
      setAssignmentData([]);
      setSelTopicDetails("");
      setQuizes([]);
    } else {
      setSelTopicDetails(e.target.value);
      setLoading(true);
      console.log(
        "selTopicDetails.topicId------------------>",
        e.target.value.topicId
      );
      getAllGamifiedQuizzes(e.target.value.topicId)
        .then((res) => {
          if (res.status === 200) {
            setQuizes(res.data);
            setLoading(false);
          } else if (res.status === 204) {
            toast.info("No quiz is there to display !");
            setLoading(false);
          } else {
            toast.error("Please try again later");
            setLoading(false);
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 500) {
              toast.error("Internal server error. Please try again later.");
              console.error(
                "The error while fetching gamified Quiz------------------------->",
                error
              );
              setLoading(false);
            } else if (error.response.status === 504) {
              toast.error("Server timeout error. Please try again later.");
              console.error(
                "The error while fetching gamified Quiz------------------------->",
                error
              );
              setLoading(false);
            } else {
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
              console.error(
                "The error while fetching gamified Quiz------------------------->",
                error
              );
              setLoading(false);
            }
          } else {
            toast.error("Some internal error occured. Please try again later.");
            console.error(
              "The error while saving gamified Quiz------------------------->",
              error
            );
          }
        });
    }
  };

  // ---------------------- Quiz Type ------------------------
  const quiz_type_select_on_change = (e) => {
    // reset();
    if (!e.target.value) {
      setShowOptions2(false);
      setShowOptions3(false);
      setShowOptions4(false);
      setShowOptionsYN(false);
    } else {
      setAnswerType(e.target.value);
      if (e.target.value === "2options") {
        setShowOptions2(true);
        setShowOptions3(false);
        setShowOptions4(false);
        setShowOptionsYN(false);
        setOptionA("");
        setOptionB("");
        setOptionC("");
        setOptionD("");
      } else if (e.target.value === "3options") {
        setShowOptions2(false);
        setShowOptions3(true);
        setShowOptions4(false);
        setShowOptionsYN(false);
        setOptionA("");
        setOptionB("");
        setOptionC("");
        setOptionD("");
      } else if (e.target.value === "4options") {
        setShowOptions2(false);
        setShowOptions3(false);
        setShowOptions4(true);
        setShowOptionsYN(false);
        setOptionA("");
        setOptionB("");
        setOptionC("");
        setOptionD("");
      } else {
        setShowOptions2(false);
        setShowOptions3(false);
        setShowOptions4(false);
        setShowOptionsYN(true);
        setOptionA("");
        setOptionB("");
        setOptionC("");
        setOptionD("");
      }
    }
  };
  // ---------------------------------------------------------

  // ---------------------- Correct Answer -------------------
  const [correctOption, setCorrectOption] = useState([]);
  const correct_answer_select_on_change = (e) => {
    const {
      target: { value },
    } = e;
    setCorrectOption(typeof value === "string" ? value.split(",") : value);
  };
  // ---------------------------------------------------------

  //On Modal close and open
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setAnswerMedia("");
    setAnswerType("");
    setInstructions("");
    setQuestion("");
    setOptionA("");
    setOptionB("");
    setOptionC("");
    setOptionD("");
    setCorrectOption("");
    setHints("");
    setLink("");
  };

  //^------------------onChange function to select files for the questionMedia----------
  const quiz_media_file_on_change = async (e) => {
    const file = e.target.files[0];
    const maxHeight = 612;
    const maxWidth = 612;

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileType = file.type;

      if (accept === "image/*" && file.size > 2097152) {
        toast.error("File size exceeds the maximum allowed (2 MB)");
        return;
      } else if (accept === "audio/*" && file.size > 5948300) {
        toast.error("File size exceeds the maximum allowed (4 MB)");
        return;
      } else if (accept === "video/*" && file.size > 20971520) {
        toast.error("File size exceeds the maximum allowed (20 MB)");
        return;
      }

      if (fileType.startsWith("video/")) {
        setFileExtensionType("mp4");
        const generatedFileName = `quiz_${new Date().getTime()}.mp4`;
        setFileName(generatedFileName);
        setSelectedFile(file);

        const videoUrl = URL.createObjectURL(file); // Create a URL for the video file
        setMyFile(videoUrl); // Set the file URL

        await uploadIfReady(file, generatedFileName);
      } else if (fileType.startsWith("audio/")) {
        setFileExtensionType("mp3");
        const generatedFileName = `quiz_${new Date().getTime()}.mp3`;
        setFileName(generatedFileName);
        setSelectedFile(file);

        setMyFile(URL.createObjectURL(file)); // Set the audio file URL

        await uploadIfReady(file, generatedFileName);
      } else if (fileType.startsWith("image/")) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          img.onload = async () => {
            const { width, height } = img;

            if (width > maxWidth || height > maxHeight) {
              toast.error("Maximum height and width exceeded");
              return;
            }

            let generatedFileName;
            if (fileExtension === "png" || fileType === "image/png") {
              setFileExtensionType("png");
              generatedFileName = `quiz_${new Date().getTime()}.png`;
            } else if (
              fileExtension === "jpg" ||
              fileExtension === "jpeg" ||
              fileType === "image/jpeg"
            ) {
              setFileExtensionType("jpg");
              generatedFileName = `quiz_${new Date().getTime()}.jpg`;
            } else {
              console.error("It is neither a PNG nor a JPG file.");
              return;
            }

            setFileName(generatedFileName);
            setSelectedFile(file);

            setMyFile(e.target.result);

            await uploadIfReady(file, generatedFileName);
          };
        };

        reader.readAsDataURL(file);
      } else {
        console.error("Unsupported file type");
        return;
      }
    }
  };
  //^---------------function to send file to Azure DB and fetch the URL------------------
  const uploadIfReady = async (file, fileName) => {
    if (file && fileName) {
      try {
        const uploadFile = await UploadFileToAzureDB(file, fileName);
        setQuestionMedia(uploadFile);
        setUpdateData({ ...updateData, questionMedia: uploadFile.url });
        console.log("uploadFile response question:---------- ", uploadFile);
      } catch (error) {
        console.error("Error uploading file: ", error);
        setQuestionMedia("");
      }
    }
  };
  //^---------------deleting the url  from the Azure DB-------------------------------------
  const quiz_media_file_on_delete = async (item) => {
    console.log("item---------------->", item);
    try {
      deleteFileFromDB(item.url);
      setQuestionMedia("");
      setUpdateData({ ...updateData, questionMedia: "" });
    } catch (error) {
      console.error("The error in deleting from Azure------------>", error);
    }
  };

  //?!----------------This contains all the functionalities and the required states to hold the url for all the options--------------
  // ---------------------- Options --------------------------
  const [optionA, setOptionA] = useState("");
  const [optionB, setOptionB] = useState("");
  const [optionC, setOptionC] = useState("");
  const [optionD, setOptionD] = useState("");
  // ---------------------------------------------------------

  //--------------------------handle option A-------------------------
  const handleOptionAchange = async (e) => {
    if (answerMedia === "text") {
      setOptionA(e.target.value);
    } else {
      const file = e.target.files[0];
      const maxHeight = 612;
      const maxWidth = 612;
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileType = file.type;
        if (accept === "image/*" && file.size > 2097152) {
          toast.error("File size exceeds the maximum allowed (2 MB)");
          return;
        }
        if (fileType.startsWith("image/")) {
          const reader = new FileReader();

          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;

            img.onload = async () => {
              const { width, height } = img;

              if (width > maxWidth || height > maxHeight) {
                toast.error("Maximum height and width exceeded");
                return;
              }

              let generatedFileName;
              if (fileExtension === "png" || fileType === "image/png") {
                setFileExtensionType("png");
                generatedFileName = `optionA_${new Date().getTime()}.png`;
              } else if (
                fileExtension === "jpg" ||
                fileExtension === "jpeg" ||
                fileType === "image/jpeg"
              ) {
                setFileExtensionType("jpg");
                generatedFileName = `optionA_${new Date().getTime()}.jpg`;
              } else {
                console.error("It is neither a PNG nor a JPG file.");
                return;
              }

              setFileName(generatedFileName);
              setSelectedFile(file);

              setMyFile(e.target.result);

              await uploadIfReadyOptionA(file, generatedFileName);
            };
          };

          reader.readAsDataURL(file);
        } else {
          console.error("Unsupported file type");
          return;
        }
      }
    }
  };

  const uploadIfReadyOptionA = async (file, fileName) => {
    try {
      const uploadFileA = await UploadFileToAzureDB(file, fileName);
      setOptionA(uploadFileA.url);
      setUpdateData({ ...updateData, optionA: uploadFileA.url });
      console.log("optionA response:---------- ", uploadFileA.url);
    } catch (error) {
      console.error("Error uploading file: ", error);
      setOptionA("");
    }
  };

  const optionADelete = async (item) => {
    console.log("data received to delete in option A---------------->", item);
    try {
      deleteFileFromDB(item);
      setOptionA("");
      setUpdateData({ ...updateData, optionA: "" });
    } catch (error) {
      console.error(
        "The error in deleting optionA from Azure------------>",
        error
      );
    }
  };
  //----------------------------------------------------------------------

  //--------------------------------handle option B---------------------------
  const handleOptionBchange = async (e) => {
    if (answerMedia === "text") {
      setOptionB(e.target.value);
    } else {
      const file = e.target.files[0];
      const maxHeight = 612;
      const maxWidth = 612;
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileType = file.type;
        if (accept === "image/*" && file.size > 2097152) {
          toast.error("File size exceeds the maximum allowed (2 MB)");
          return;
        }
        if (fileType.startsWith("image/")) {
          const reader = new FileReader();

          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;

            img.onload = async () => {
              const { width, height } = img;

              if (width > maxWidth || height > maxHeight) {
                toast.error("Maximum height and width exceeded");
                return;
              }

              let generatedFileName;
              if (fileExtension === "png" || fileType === "image/png") {
                setFileExtensionType("png");
                generatedFileName = `optionB_${new Date().getTime()}.png`;
              } else if (
                fileExtension === "jpg" ||
                fileExtension === "jpeg" ||
                fileType === "image/jpeg"
              ) {
                setFileExtensionType("jpg");
                generatedFileName = `optionB_${new Date().getTime()}.jpg`;
              } else {
                console.error("It is neither a PNG nor a JPG file.");
                return;
              }

              setFileName(generatedFileName);
              setSelectedFile(file);

              setMyFile(e.target.result);

              await uploadIfReadyOptionB(file, generatedFileName);
            };
          };

          reader.readAsDataURL(file);
        } else {
          console.error("Unsupported file type");
          return;
        }
      }
    }
  };
  const uploadIfReadyOptionB = async (file, fileName) => {
    try {
      const uploadFileB = await UploadFileToAzureDB(file, fileName);
      setOptionB(uploadFileB.url);
      setUpdateData({ ...updateData, optionB: uploadFileB.url });
      console.log("optionB response:---------- ", uploadFileB.url);
    } catch (error) {
      console.error("Error uploading file: ", error);
      setOptionB("");
    }
  };
  const optionBDelete = async (item) => {
    console.log("item received to delete in optionB---------------->", item);
    try {
      deleteFileFromDB(item);
      setOptionB("");
      setUpdateData({ ...updateData, optionB: "" });
    } catch (error) {
      console.error(
        "The error in deleting optionB from Azure------------>",
        error
      );
    }
  };

  //------------------------------------------------------------------------------

  //---------------------------------Handle option C--------------------------
  const handleOptionCchange = async (e) => {
    if (answerMedia === "text") {
      setOptionC(e.target.value);
    } else {
      const file = e.target.files[0];
      const maxHeight = 612;
      const maxWidth = 612;
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileType = file.type;
        if (accept === "image/*" && file.size > 2097152) {
          toast.error("File size exceeds the maximum allowed (2 MB)");
          return;
        }
        if (fileType.startsWith("image/")) {
          const reader = new FileReader();

          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;

            img.onload = async () => {
              const { width, height } = img;

              if (width > maxWidth || height > maxHeight) {
                toast.error("Maximum height and width exceeded");
                return;
              }

              let generatedFileName;
              if (fileExtension === "png" || fileType === "image/png") {
                setFileExtensionType("png");
                generatedFileName = `optionC_${new Date().getTime()}.png`;
              } else if (
                fileExtension === "jpg" ||
                fileExtension === "jpeg" ||
                fileType === "image/jpeg"
              ) {
                setFileExtensionType("jpg");
                generatedFileName = `optionC_${new Date().getTime()}.jpg`;
              } else {
                console.error("It is neither a PNG nor a JPG file.");
                return;
              }

              setFileName(generatedFileName);
              setSelectedFile(file);

              setMyFile(e.target.result);

              await uploadIfReadyOptionC(file, generatedFileName);
            };
          };

          reader.readAsDataURL(file);
        } else {
          console.error("Unsupported file type");
          return;
        }
      }
    }
  };
  const uploadIfReadyOptionC = async (file, fileName) => {
    try {
      const uploadFileC = await UploadFileToAzureDB(file, fileName);
      setOptionC(uploadFileC.url);
      setUpdateData({ ...updateData, optionC: uploadFileC.url });
      console.log("optionC response:---------- ", uploadFileC.url);
    } catch (error) {
      console.error("Error uploading file: ", error);
      setOptionC("");
    }
  };
  const optionCDelete = async (item) => {
    console.log("item received for optionC delete---------------->", item);
    try {
      deleteFileFromDB(item);
      setOptionC("");
      setUpdateData({ ...updateData, optionC: "" });
    } catch (error) {
      console.error(
        "The error in deleting optionC from Azure------------>",
        error
      );
    }
  };
  //-----------------------------------------------------------------------------

  //---------------------------------Handle option C--------------------------
  const handleOptionDchange = async (e) => {
    if (answerMedia === "text") {
      setOptionD(e.target.value);
    } else {
      const file = e.target.files[0];
      const maxHeight = 612;
      const maxWidth = 612;
      if (file) {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileType = file.type;
        if (accept === "image/*" && file.size > 2097152) {
          toast.error("File size exceeds the maximum allowed (2 MB)");
          return;
        }
        if (fileType.startsWith("image/")) {
          const reader = new FileReader();

          reader.onload = (e) => {
            const img = new Image();
            img.src = e.target.result;

            img.onload = async () => {
              const { width, height } = img;

              if (width > maxWidth || height > maxHeight) {
                toast.error("Maximum height and width exceeded");
                return;
              }

              let generatedFileName;
              if (fileExtension === "png" || fileType === "image/png") {
                setFileExtensionType("png");
                generatedFileName = `optionC_${new Date().getTime()}.png`;
              } else if (
                fileExtension === "jpg" ||
                fileExtension === "jpeg" ||
                fileType === "image/jpeg"
              ) {
                setFileExtensionType("jpg");
                generatedFileName = `optionC_${new Date().getTime()}.jpg`;
              } else {
                console.error("It is neither a PNG nor a JPG file.");
                return;
              }

              setFileName(generatedFileName);
              setSelectedFile(file);

              setMyFile(e.target.result);

              await uploadIfReadyOptionD(file, generatedFileName);
            };
          };

          reader.readAsDataURL(file);
        } else {
          console.error("Unsupported file type");
          return;
        }
      }
    }
  };
  const uploadIfReadyOptionD = async (file, fileName) => {
    try {
      const uploadFileD = await UploadFileToAzureDB(file, fileName);
      setOptionD(uploadFileD.url);
      setUpdateData({ ...updateData, optionD: uploadFileD.url });
      console.log("optionD response:---------- ", uploadFileD.url);
    } catch (error) {
      console.error("Error uploading file: ", error);
      setOptionD("");
    }
  };
  const optionDDelete = async (item) => {
    console.log("item received in optionD delete---------------->", item);
    try {
      deleteFileFromDB(item);
      setOptionD("");
      setUpdateData({ ...updateData, optionD: "" });
    } catch (error) {
      console.error(
        "The error in deleting optionD from Azure------------>",
        error
      );
    }
  };
  //-----------------------------------------------------------------------------
  //?!---------------------------------------------------------------------------------------------------------------------------------------------

  //&--------------------Delete Functionalities for the array of quizes-------------------------------------------------------------
  const deleteQuestionOnClick = (item) => {
    console.log("item received upon deleting --------------------->", item);
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this question?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (item.questionMedia) {
          //if the question media is there, then we will have to delete that from Azure as well
          quiz_media_file_on_delete(item.questionMedia);
        }

        if (item.answerMedia && item.answerMedia === "image") {
          //If the answermedia is image, then also we will be deleting it
          if (answerType === "4options") {
            optionDDelete(item.optionD);
            optionCDelete(item.optionC);
            optionBDelete(item.optionB);
            optionADelete(item.optionA);
          } else if (answerType === "3options") {
            optionCDelete(item.optionC);
            optionBDelete(item.optionB);
            optionADelete(item.optionA);
          } else {
            optionBDelete(item.optionB);
            optionADelete(item.optionA);
          }
        }

        const newQuiz = quizes.filter((x) => x.questionId !== item.questionId); //This new array will be used as updated Quiz Array for the update method
        console.log("NewQuiz------------------->", newQuiz);
        const data = {
          topicId: selTopicDetails.topicId,
          quizType: "gamified",
          gamifiedData: newQuiz,
        };
        console.log("body sent for delete------------------>", data);
        deleteGamifiedQuiz(data)
          .then((res) => {
            if (res.status === 200) {
              toast.success("Successfully deleted the question.");
              getAllGamifiedQuizzes(selTopicDetails.topicId)
                .then((res) => {
                  if (res.status === 200) {
                    setQuizes(res.data);
                    resetAll();
                    handleClose();
                  } else if (res.status === 204) {
                    toast.info("No data is there to display !");
                  } else {
                    toast.info("Please try again later.");
                    console.log(
                      "response status while receiving gamified quizes--------------------->",
                      res.status
                    );
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    if (error.response.status === 500) {
                      console.error(
                        "The error while fetching gamified Quiz------------------------->",
                        error
                      );
                    } else if (error.response.status === 504) {
                      console.error(
                        "The error while fetching gamified Quiz------------------------->",
                        error
                      );
                    } else {
                      console.error(
                        "The error while fetching gamified Quiz------------------------->",
                        error
                      );
                    }
                  } else {
                    toast.error(
                      "Some internal error occured. Please try again later."
                    );
                    console.error(
                      "The error while saving gamified Quiz------------------------->",
                      error
                    );
                  }
                });
            } else {
              toast.error(
                "Sorry, couldn't delete this time. Please try again later !"
              );
              console.log(
                "The status code received-------------------->",
                res.status
              );
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status === 500) {
                toast.error("Internal server error. Please try again later.");
                console.error(
                  "The error while fetching gamified Quiz------------------------->",
                  error
                );
                setLoading(false);
              } else if (error.response.status === 504) {
                toast.error("Server timeout error. Please try again later.");
                console.error(
                  "The error while fetching gamified Quiz------------------------->",
                  error
                );
                setLoading(false);
              } else {
                toast.error(
                  "An unexpected error occurred. Please try again later."
                );
                console.error(
                  "The error while fetching gamified Quiz------------------------->",
                  error
                );
                setLoading(false);
              }
            } else {
              toast.error(
                "Some internal error occured. Please try again later."
              );
              console.error(
                "The error while saving gamified Quiz------------------------->",
                error
              );
            }
          });
        setQuizes((quizes) =>
          quizes.filter((i) => i.questionId !== item.questionId)
        );
      }
    });
  };
  //&--------------------------------------------------------------------------------------------------------------------------------------

  //^------------------Changing the QuizMedia types---------------------------------------
  const quiz_media_type_select_on_change = (e) => {
    setSelectedFile(null);
    setQuestionMediaType(e.target.value);
    if (e.target.value === "image") {
      setAccept("image/*");
      setShowUploadPanel(true);
    } else if (e.target.value === "audio") {
      setAccept("audio/*");
      setShowUploadPanel(true);
    } else if (e.target.value === "video") {
      setAccept("video/*");
      setShowUploadPanel(true);
    } else {
      setAccept("");
      setShowUploadPanel(false);
    }
  };

  const handleAnswerMedia = (e) => {
    setAnswerMedia(e.target.value);
    setAnswerType("");
    setOptionA("");
    setOptionB("");
    setOptionC("");
    setOptionD("");
    setCorrectOption([]);
  };

  const resetAll = () => {
    setQuestionOrder(0);
    setSelectedFile(null);
    setMyFile("");
    setFileExtensionType("");
    setAccept("");
    setFileName("");
    setQuestionId("");
    setQuestion("");
    setAnswerMedia("");
    setQuestionMedia("");
    setQuestionMediaType("");
    setInstructions("");
    setCorrectOption([]);
    setHints("");
    setOptionA("");
    setOptionB("");
    setOptionC("");
    setOptionD("");
    // reset();
  };
  //^------------------Save function for the Quiz---------------------
  const handleSave = () => {
    setLoadingSave(true);
    if (!question || question.trim() === "") {
      toast.error("Please add a question");
      setLoadingSave(false);
    } else {
      const data = {
        topicId: selTopicDetails.topicId,
        quizType: "gamified",
        gamifiedData: [
          ...quizes,
          {
            optionA,
            optionB,
            optionC,
            optionD,
            hints,
            question,
            answerMedia,
            questionId: new Date().getTime(),
            correctOption,
            answerType,
            questionMediaType,
            questionMedia: questionMedia.url,
            instructions,
            answerType,
          },
        ],
      };
      console.log("body sent for saving------------------>", data);
      saveGamifiedQuiz(data)
        .then((res) => {
          if (res.status === 200) {
            toast.success("Quiz saved successfully!");
            setLoadingSave(false);
            getAllGamifiedQuizzes(selTopicDetails.topicId)
              .then((res) => {
                if (res.status === 200) {
                  setQuizes(res.data);
                  resetAll();
                  handleClose();
                } else if (res.status === 204) {
                  toast.info("No data is there to display!");
                } else {
                  toast.info("Please try again later.");
                  console.log(
                    "response status while receiving gamified quizes--------------------->",
                    res.status
                  );
                }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.status === 500) {
                    console.error(
                      "The error while fetching gamified Quiz------------------------->",
                      error
                    );
                  } else if (error.response.status === 504) {
                    console.error(
                      "The error while fetching gamified Quiz------------------------->",
                      error
                    );
                  } else {
                    console.error(
                      "The error while fetching gamified Quiz------------------------->",
                      error
                    );
                  }
                } else {
                  toast.error(
                    "Some internal error occurred. Please try again later."
                  );
                  console.error(
                    "The error while saving gamified Quiz------------------------->",
                    error
                  );
                }
              });
          } else {
            toast.error("Sorry something went wrong. Please try again later.");
            console.log(
              "Status code while saving quiz--------------->",
              res.status
            );
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 500) {
              toast.error("Internal server error. Please try again later.");
              console.error(
                "The error while saving gamified Quiz------------------------->",
                error
              );
              setLoadingSave(false);
            } else if (error.response.status === 504) {
              toast.error("Server timeout error. Please try again later.");
              console.error(
                "The error while saving gamified Quiz------------------------->",
                error
              );
              setLoadingSave(false);
            } else {
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
              console.error(
                "The error while saving gamified Quiz------------------------->",
                error
              );
              setLoadingSave(false);
            }
          }
        });
    }
  };
  const linkOnchange = (e) => {
    setLink(e.target.value);
  };

  const handleKeyPress = (event) => {
    event.preventDefault();
  };
  //^------------------------------------------------------------------------

  //?--------------This contains the states and the functionalities for editing the quiz--------------------------------------------
  const [showUpdate, setShowUpdate] = useState(false);
  const [updateData, setUpdateData] = useState({
    questionId: "",
    question: "",
    questionMediaType: "",
    questionMedia: "",
    instructions: "",
    hints: "",
    answerType: "",
    optionA: "",
    optionB: "",
    optionC: "",
    optionD: "",
    correctOption: [],
    answerType: "",
    answerMedia: "",
  });

  const handleShowUpdate = (item) => {
    setShowUpdate(true);
    console.log(
      "item.questionMedia-------------------------?",
      item.questionMedia
    );
    const newUpdateData = {
      questionId: item.questionId,
      question: item.question,
      questionMediaType: item.questionMediaType,
      questionMedia: item.questionMedia,
      instructions: item.instructions,
      hints: item.hints,
      answerType: item.answerType,
      optionA: item.optionA,
      optionB: item.optionB ? item.optionB : "",
      optionC: item.optionC ? item.optionC : "",
      optionD: item.optionD ? item.optionD : "",
      correctOption: item.correctOption,
      answerMedia: item.answerMedia,
    };
    setUpdateData(newUpdateData);
  };

  const updateQuiz = () => {
    setLoadingUpdate(true);
    if (!updateData.question || updateData.question.trim() === "") {
      toast.error("Please add a question before proceeding!");
      setLoadingUpdate(false);
    } else {
      const newData = quizes.map((item) => {
        if (item.questionId == updateData.questionId) {
          item.optionA = updateData.optionA ? updateData.optionA : "";
          item.optionB = updateData.optionB ? updateData.optionB : "";
          item.optionC = updateData.optionC ? updateData.optionC : "";
          item.optionD = updateData.optionD ? updateData.optionD : "";
          item.correctOption = updateData.correctOption;
          item.question = updateData.question;
          item.questionId = updateData.questionId;
          item.questionMediaType = updateData.questionMediaType;
          item.answerType = updateData.answerType;
          item.questionMedia = updateData.questionMedia;
          item.answerMedia = updateData.answerMedia
            ? updateData.answerMedia
            : "";
          item.questionMedia = updateData.questionMedia
            ? updateData.questionMedia
            : "";
          item.instructions = updateData.instructions;
          item.hints = updateData.hints;
        }
        return item;
      });

      console.log("newData-------------------------------->", newData);

      const data = {
        topicId: selTopicDetails.topicId,
        quizType: "gamified",
        gamifiedData: newData,
      };

      console.log(
        "data passed for updating---------------------------->",
        data
      );

      updateGamifiedQuiz(data)
        .then((res) => {
          if (res.status === 200) {
            toast.success("Question updated successfully!");
            setLoadingUpdate(false);
            setShowUpdate(false);
            getAllGamifiedQuizzes(selTopicDetails.topicId)
              .then((res) => {
                if (res.status === 200) {
                  setQuizes(res.data);
                  resetAll();
                  handleClose();
                  setUpdateData({
                    questionId: "",
                    question: "",
                    questionMediaType: "",
                    questionMedia: "",
                    instructions: "",
                    hints: "",
                    answerType: "",
                    optionA: "",
                    optionB: "",
                    optionC: "",
                    optionD: "",
                    correctOption: [],
                    answerType: "",
                    answerMedia: "",
                  });
                } else if (res.status === 204) {
                  toast.info("No data is there to display!");
                } else {
                  toast.info("Please try again later.");
                  console.log(
                    "response status while receiving gamified quizzes--------------------->",
                    res.status
                  );
                }
              })
              .catch((error) => {
                if (error.response) {
                  if (error.response.status === 500) {
                    console.error(
                      "The error while fetching gamified Quiz------------------------->",
                      error
                    );
                  } else if (error.response.status === 504) {
                    console.error(
                      "The error while fetching gamified Quiz------------------------->",
                      error
                    );
                  } else {
                    console.error(
                      "The error while fetching gamified Quiz------------------------->",
                      error
                    );
                  }
                } else {
                  toast.error(
                    "Some internal error occurred. Please try again later."
                  );
                  console.error(
                    "The error while saving gamified Quiz------------------------->",
                    error
                  );
                }
              });
          } else {
            toast.error(
              "Sorry, couldn't update due to some internal problems. Please try again later."
            );
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 500) {
              toast.error("Internal server error. Please try again later.");
              console.error(
                "The error while updating gamified Quiz------------------------->",
                error
              );
              setLoadingUpdate(false);
            } else if (error.response.status === 504) {
              toast.error("Server timeout error. Please try again later.");
              console.error(
                "The error while updating gamified Quiz------------------------->",
                error
              );
              setLoadingUpdate(false);
            } else {
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
              console.error(
                "The error while updating gamified Quiz------------------------->",
                error
              );
              setLoadingUpdate(false);
            }
          }
        });
    }
  };

  const handleCloseUpdate = () => {
    setShowUpdate(false);
    setSelectedFile(null);
    setMyFile("");
    setFileExtensionType("");
    setAccept("");
    setFileName("");
    setQuestionId("");
    setQuestion("");
    setAnswerMedia("");
    setQuestionMedia("");
    setQuestionMediaType("");
    setInstructions("");
    setCorrectOption([]);
    setHints("");
    setOptionA("");
    setOptionB("");
    setOptionC("");
    setOptionD("");
    setLink("");
  };

  //?-----------------------------------------------------------------------------------------------------------------------------------------

  const close_quiz_dialog = () => {
    resetAll();
    // setShow(false);
    handleClose();
  };

  //todo-------------------Console logs--------------------------------------
  // console.log("question---------------------------------->", question); //^----While uploading our questions
  // console.log("hints------------------------------>", hints); //^----while setting hints
  // console.log(
  //   "questionMediaType--------------------------->",
  //   questionMediaType
  // ); //^-----While setting the question media (image, video or audio)
  // console.log("instructions---------------------->", instructions); //^----While setting instructions
  // console.log("answerMedia----------------------------->", answerMedia); //^----While setting the answer media
  // console.log("answerType------------------------------->", answerType); //^---While setting the Quiz type (2/3/4 or YN options)
  // console.log("myFile------------------------------------->", myFile);
  // console.log("correct answer----------------------->", correctOption); //^----While choosing the correct options
  // console.log("optionA-------------------------------->", optionA);
  // console.log("optionB-------------------------------->", optionB);
  // console.log("optionC-------------------------------->", optionC);
  // console.log("optionD-------------------------------->", optionD);
  // console.log("quizData---------------------------->", quizData);
  // console.log("quizes------------------------------------->", quizes); //^-------To store the data fetched
  // console.log("questionMedia------------------------------>", questionMedia);
  // console.log("updateData---------------------->", updateData);
  // console.log("accept----------------------------->", accept);
  console.log(
    "updateData QuestionMedia---------------------->",
    updateData.questionMedia
  );

  return (
    <div>
      <div className="header-div">
        <MuiHeader header="Training Extra-resources" />
        <div style={{ display: "flex", marginLeft: "100px" }}>
          <Grid item>
            <FormControl
              sx={{ m: 1 }}
              style={{ width: "130px", marginLeft: "-64px" }}
              size="small"
            >
              <InputLabel id="demo-select-small">Language</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={preferedlanguage}
                label="Language" //
                onChange={preflanguage_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {language_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Usertype</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={usertype}
                label="Usertype"
                onChange={usertype_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {usertype_select_option_list.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.text}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "150px" }} size="small">
              <InputLabel id="demo-select-small">Trainingtype</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={programtype}
                label="Trainingtype"
                onChange={program_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {usertype
                  ? programData.map((option) => (
                      <MenuItem
                        key={option.trainingType}
                        value={option.trainingType}
                      >
                        {option.trainingName}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Module</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={selModuleDetails}
                label="Module"
                onChange={module_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {usertype && programtype && Array.isArray(modules)
                  ? modules.map(
                      (
                        option //
                      ) => (
                        <MenuItem key={option.moduleId} value={option.moduleId}>
                          {option.moduleName}
                        </MenuItem>
                      )
                    )
                  : null}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "140px" }} size="small">
              <InputLabel id="demo-select-small">Sub-Module</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={selSubModuleDetails}
                label="Submodule"
                onChange={submodule_select_onchange} //
              >
                <MenuItem value="">None</MenuItem>
                {usertype &&
                usertype != "" &&
                programtype &&
                Array.isArray(subModules)
                  ? subModules.map((option) => (
                      <MenuItem
                        key={option.submoduleId}
                        value={option.submoduleId}
                      >
                        {option.submoduleName}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </Grid>
          <Grid item>
            <FormControl sx={{ m: 1 }} style={{ width: "130px" }} size="small">
              <InputLabel id="demo-select-small">Topic</InputLabel>
              <Select
                labelId="demo-select-small"
                id="demo-select-small"
                value={selTopicDetails}
                label="Topic"
                onChange={topic_select_onchange}
              >
                <MenuItem value="">None</MenuItem>
                {usertype &&
                usertype != "" &&
                programtype &&
                Array.isArray(topics)
                  ? topics.map((option) => (
                      <MenuItem key={option.topicId} value={option}>
                        {option.topicName}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            </FormControl>
          </Grid>
        </div>
      </div>
      <div className="quiz-open-modal-button">
        <Button
          variant="contained"
          onClick={handleShow}
          disabled={selTopicDetails ? false : true}
        >
          Add Extra resources ➕
        </Button>
      </div>

      <div style={{ margin: "7%" }}>
        {selTopicDetails && quizes && quizes.length > 0 ? (
          <>
            {quizes.map((item, index) => (
              <div key={index}>
                <div
                  style={{
                    border: "2px solid blue",
                    padding: "20px",
                    marginTop: "20px",
                    width: "70%",
                  }}
                >
                  <div className="question">
                    <>
                      <b>
                        {index + 1}. {item.question}
                      </b>
                    </>
                  </div>

                  <div
                    className="correctOption"
                    style={{ marginTop: "9px", paddingBottom: "20px" }}
                  >
                    <div>
                      <Button
                        style={{ color: "blue" }}
                        onClick={() => handleShowUpdate(item)}
                      >
                        <ModeEditOutlineIcon />
                      </Button>
                      <Button
                        style={{ color: "red" }}
                        onClick={() => deleteQuestionOnClick(item)}
                      >
                        <DeleteIcon />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : null}
      </div>
      {/* ----------------save modal----------------- */}
      <Modal
        open={show}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div>
            {/* --------------------- */}
            <div>
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <div>
                    {/* Add Question */}
                    <div className="quiz-parent-segment-title">Add Label</div>
                    <div>
                      <TextField
                        id="add-question"
                        label="Add Label"
                        variant="outlined"
                        multiline
                        rows={3}
                        style={{ width: "470px" }}
                        size="small"
                        value={question}
                        onChange={(e) => setQuestion(e.target.value)}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
            {/* --------------------- */}

            {/* Add Link */}
            <div>
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <div>
                    {/* Add Link */}
                    <div className="quiz-parent-segment-title">Add Link</div>
                    <div>
                      <TextField
                        id="add-link"
                        label="Add Link"
                        variant="outlined"
                        type="url"
                        style={{ width: "470px" }}
                        size="small"
                        value={link}
                        onChange={linkOnchange}
                        onKeyPress={handleKeyPress}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
            {/* --------------------- */}
          </div>

          <div style={{ marginBottom: "100px" }}>
            <Button
              variant="outlined"
              style={{ marginLeft: 12 }}
              onClick={close_quiz_dialog}
            >
              Close
            </Button>
            {loadingSave ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "right",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Button variant="contained" onClick={handleSave}>
                Save
              </Button>
            )}
          </div>
        </Box>
      </Modal>

      {/**----------------Update Modal--------------- */}
      <Modal
        open={showUpdate}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div>
            <div>
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <div>
                    <div className="quiz-parent-segment-title ">
                      Add Question
                    </div>
                    <div>
                      <TextField
                        id="add-question"
                        label="Add Question"
                        variant="outlined"
                        multiline
                        rows={3}
                        style={{ width: "470px" }}
                        size="small"
                        value={updateData.question}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            question: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <div>
                    <div className="quiz-parent-segment-title ">Add Link</div>
                    <div>
                      <TextField
                        id="add-link"
                        label="Add Link"
                        variant="outlined"
                        style={{ width: "470px" }}
                        size="small"
                        value={updateData.link}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            link: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
            {/* --------------------- */}
          </div>
          <div style={{ marginBottom: "100px" }}>
            <Button
              variant="outlined"
              style={{ marginLeft: 12 }}
              onClick={handleCloseUpdate}
            >
              Close
            </Button>
            {loadingUpdate ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "right",
                }}
              >
                <CircularProgress />
              </div>
            ) : (
              <Button variant="contained" onClick={updateQuiz}>
                Update
              </Button>
            )}
          </div>
        </Box>
      </Modal>

      <ToastContainer />
    </div>
  );
};

export default GamifiedModule;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "45%",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  height: "45%",
  p: 4,
  overflowY: "auto",
  paddingBottom: "20px",
};
